var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1600px",
    height: "1200px",
    viewBox: "0 0 1600 1200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Taieri") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Patterns",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Taieri",
    strokeWidth: 13
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, -106.000000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1600,999 C1600,1031.03292 1574.25677,1057 1542.5,1057 C1510.74323,1057 1485,1031.03292 1485,999",
    stroke: "#44AB96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1600,155 C1560.232,155 1528,122.540542 1528,82.5 C1528,42.4593375 1560.232,10 1600,10",
    stroke: "#E53855"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562,68.9061033 C562,102.094761 588.86303,129 622,129 C655.13697,129 682,102.094761 682,68.9061033 L682,1",
    stroke: "#44AB96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.235431,1412 C62.5469552,1412 2,1351.78723 2,1277.5 C2,1203.21277 62.5469552,1143 137.235431,1143 L261,1143",
    stroke: "#FFB017"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.980392,1320 C104.137843,1320 84,1300.5263 84,1276.5 C84,1252.4737 104.137843,1233 128.980392,1233 L177,1233",
    stroke: "#44AB96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1600,462 L1600,293.680945 C1600,260.719685 1573.132,234 1540,234 C1506.868,234 1480,260.719685 1480,293.680945 L1480,319.733984",
    stroke: "#DA774A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673,965.536122 L493.562942,965.536122 C448.334856,965.536122 411.669456,1002.00747 411.669456,1046.9962 C411.669456,1091.98492 448.334856,1128.45627 493.562942,1128.45627 L567.622353,1128.45627 M366.840065,1412 L356.143341,1412 C324.5844,1412 299,1386.38214 299,1354.796 C299,1323.19782 324.5844,1297.57996 356.143341,1297.57996 L483.722806,1297.57996 C530.353311,1297.57996 568.154812,1259.73675 568.154812,1213.04943 M389.761506,588 L389.761506,652.28545 C389.761506,730.58941 453.166266,794.066215 531.380153,794.066215 L587.786614,794.066215 C634.848407,794.066215 673,832.261158 673,879.376426",
    stroke: "#DA774A"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#44AB96",
    cx: 588,
    cy: 393,
    r: 40
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#E53855",
    cx: 698,
    cy: 1195.5,
    rx: 58,
    ry: 57.5
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#44AB96",
    cx: 184,
    cy: 257,
    r: 63
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.5,394 C262.09546,394 325,331.991571 325,255.5 C325,179.008429 262.09546,117 184.5,117 C106.90454,117 44,179.008429 44,255.5",
    stroke: "#FFB017"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1311.21029,1224.45737 C1289.86431,1304.2718 1336.04182,1386.01294 1414.34647,1407.03829 C1492.65112,1428.05159 1573.44373,1380.38933 1594.78971,1300.5749 C1616.13569,1220.76047 1569.95818,1139.02294 1491.65353,1118",
    stroke: "#44AB96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.830303,1213 C396.873001,1213 328,1137.56528 328,1044.51186 C328,1012.20051 336.304343,982.012947 350.703128,956.37037 M587,875 L482.202584,875 C448.669684,875 417.63933,886.601448 392.357576,906.296296",
    stroke: "#DA774A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.5,414 C296.743229,414 271,439.743053 271,471.5 C271,503.256947 296.743229,529 328.5,529 C360.256771,529 386,503.256947 386,471.5 L386,414",
    stroke: "#44AB96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346,77.5 C346,119.749516 380.026457,154 422,154 C463.973543,154 498,119.749516 498,77.5 C498,35.2502453 463.973543,1 422,1 L346,1",
    stroke: "#E53855"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5,866.5824 C34.7730685,866.5824 5,837.1272 5,800.7912 C5,764.4552 34.7730685,735 71.5,735 C108.227171,735 138,764.4552 138,800.7912 L138,1002",
    stroke: "#44AB96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1461.98822,870 C1461.98822,903.688911 1488.85977,931 1522.00014,931 C1555.14051,931 1582,903.688911 1582,870 C1582,836.311089 1555.14051,809 1522.00014,809 L1321,809",
    stroke: "#44AB96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966,139.790824 C930.653887,139.790824 902,168.043394 902,202.895412 C902,237.74743 930.653887,266 966,266 C1001.34611,266 1030,237.74743 1030,202.895412 L1030,0",
    stroke: "#4484AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.918699,1354 C914.918699,1321.96708 940.681163,1296 972.45935,1296 C1004.23875,1296 1030,1321.96708 1030,1354 C1030,1386.03292 1004.23875,1412 972.45935,1412 L881,1412",
    stroke: "#44AB96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1089.5,562.577778 C1121.25677,562.577778 1147,588.191493 1147,619.788889 C1147,651.386284 1121.25677,677 1089.5,677 C1057.74323,677 1032,651.386284 1032,619.788889 L1032,406",
    stroke: "#DA774A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5,568.708075 C30.7435885,568.708075 5,594.06877 5,625.354037 C5,656.639304 30.7435885,682 62.5,682 C94.2564115,682 120,656.639304 120,625.354037 L120,394",
    stroke: "#DA774A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.703935,394 C688.703935,337.115088 643.326663,291 587.351967,291 C531.377271,291 486,337.115088 486,394 C486,450.884912 531.377271,497 587.351967,497 L853,497",
    stroke: "#FFB017"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1498.64324,727 C1554.62873,727 1600,680.884912 1600,624 C1600,567.115088 1554.62873,521 1498.64324,521 L1233,521",
    stroke: "#44AB96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1107,175.5 C1107,122.20424 1149.73931,79 1202.46154,79 L1300.53846,79 C1353.26462,79 1396,122.20424 1396,175.5 L1396,175.5 C1396,228.79576 1353.26462,272 1300.53846,272 L1202.46154,272 C1149.73931,272 1107,228.79576 1107,175.5 L1107,175.5 Z",
    stroke: "#DA774A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.5,871 C233.639172,871 207,844.4056 207,811.6 L207,642.4 C207,609.5944 233.639172,583 266.5,583 L266.5,583 C299.360828,583 326,609.5944 326,642.4 L326,811.6 C326,844.4056 299.360828,871 266.5,871 L266.5,871 Z",
    stroke: "#FFB017"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M828,795.5 L828,706.165929 C828,680.669146 848.818714,660 874.5,660 L874.5,660 C900.181286,660 921,680.669146 921,706.165929 L921,884.834071 C921,910.330854 900.181286,931 874.5,931 L874.5,931 L874.5,931 C848.818714,931 828,910.330854 828,884.834071 L828,863.25",
    stroke: "#E53855"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914,317.930473 L914,325.718935 C914,370.056849 877.958828,406 833.5,406 L833.5,406 C789.041172,406 753,370.056849 753,325.718935 L753,81.2810651 C753,36.9430311 789.041172,1 833.5,1 L833.5,1 C877.958828,1 914,36.9430311 914,81.2810651 L914,83.6775148",
    stroke: "#FFB017"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.75,952 L66.9391892,952 C32.7311973,952 5,979.757942 5,1014 L5,1014 C5,1048.24206 32.731077,1076 66.9391892,1076 L210.060811,1076 C244.269284,1076 272,1048.24206 272,1014 L272,1014 C272,979.757942 244.269284,952 210.060811,952 L205.25,952",
    stroke: "#FFB017"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751,660 L751,891.636695 C751,960.873131 807.635857,1017 877.5,1017 C947.364143,1017 1004,960.873131 1004,891.636695 L1004,836.909074",
    stroke: "#44AB96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497,1052 L704.801584,1052 C783.887993,1052 848,1116.4712 848,1196 C848,1275.524 783.887993,1340 704.801584,1340 L642.287645,1340",
    stroke: "#44AB96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586,701 L536.813451,701 C503.779264,701 477,674.1368 477,641 C477,607.8632 503.779264,581 536.813451,581 L635.186549,581 C668.220736,581 695,607.8632 695,641 L695,646.3304 C695,676.5236 670.599571,701 640.5,701",
    stroke: "#4484AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1089.5,472 L1145.68138,472 C1183.41029,472 1214,443.121917 1214,407.5 C1214,371.878083 1183.41029,343 1145.68138,343 L1033.31862,343 C995.587304,343 965,371.878083 965,407.5",
    stroke: "#44AB96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675,203 L540.31882,203 C455.090745,203 386,272.395543 386,358",
    stroke: "#44AB96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1449.5,1206.84034 C1481.25677,1206.84034 1507,1232.40008 1507,1263.92017 C1507,1295.44025 1481.25677,1321 1449.5,1321 C1417.74323,1321 1392,1295.44025 1392,1263.92017 L1392,892",
    stroke: "#E53855"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019,1244 C1019,1185.45909 1065.8466,1138 1123.63468,1138 L1308,1138",
    stroke: "#44AB96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747,581 L845.373099,581 C911.441473,581 965,527.2736 965,461",
    stroke: "#4484AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1321,894 L1321,947.75513 C1321,1002.01372 1276.99829,1046 1222.71233,1046 L1146,1046",
    stroke: "#4484AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1507,626 L1422.99321,626 C1362.24247,626 1313,675.69663 1313,737",
    stroke: "#DA774A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,1412 L218,1320.88212 C218,1268.41848 258.9752,1224.46964 314,1213",
    stroke: "#44AB96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5,326 C44.5,335.313046 44.5,452.547503 44.5,510",
    stroke: "#44AB96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.5,749 C1088.5,756.692889 1088.5,853.538603 1088.5,901",
    stroke: "#44AB96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M934.5,1162 C934.5,1165.13815 934.5,1204.63692 934.5,1224",
    stroke: "#44AB96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233,587 L1233,729.3306 C1233,751.72569 1214.70469,769.866206 1192.13523,769.866206 C1169.56577,769.866206 1151.27047,788.021141 1151.27047,810.417433 L1151.27047,818.828058 C1151.27047,841.223148 1169.56577,859.379284 1192.13523,859.379284 C1214.70469,859.379284 1233,877.534218 1233,899.93051 L1233,909.242274 C1233,936.781062 1210.50319,959.105263 1182.75147,959.105263 L1156.7191,959.105263 L1118.57865,959.105263 M954,1092 L980.776066,1092 C1036.10685,1092 1080.96067,1047.20111 1080.96067,991.93808",
    stroke: "#FFB017"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1481,389.9208 L1481,410.2032 C1481,438.81 1457.73657,462 1429.05744,462 L1429.05744,462 C1400.36628,462 1377.10285,438.81 1377.10285,410.2032 L1377.10285,393.4032 C1377.10285,365.0136 1354.01994,342 1325.55744,342 L1325.55744,342 C1297.08291,342 1274,365.0136 1274,393.4032 L1274,414.0792",
    stroke: "#E53855"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1089,1285.96667 C1089,1245.67218 1121.68349,1213 1162,1213 L1162,1213 C1202.31289,1213 1235,1245.67218 1235,1285.96667 L1235,1339.03333 C1235,1379.32782 1202.31289,1412 1162,1412 L1162,1412 C1121.68349,1412 1089,1379.32782 1089,1339.03333 L1089,1285.96667 Z",
    stroke: "#4484AB"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHh);
export default __webpack_public_path__ + "static/media/hh.8cacd8ebf3a943aec31a375ea5e89b95.svg";
export { ForwardRef as ReactComponent };